import "./styles.scss"
import { Link } from "react-router-dom";
import { ReactComponent as Google } from 'assets/icons/googleIcon.svg'




const GoogleButton = () => {

    return (
        <Link to={"https://dashboard-ping-proxies.goodface.com.ua/"} className="google-btn">
            <Google />
            Start with Google
        </Link>
    )
}






export default GoogleButton;